import { render, staticRenderFns } from "./IndSubAnRePunMan.vue?vue&type=template&id=537f7a3a&scoped=true&"
import script from "./IndSubAnRePunMan.vue?vue&type=script&lang=js&"
export * from "./IndSubAnRePunMan.vue?vue&type=script&lang=js&"
import style0 from "./IndSubAnRePunMan.vue?vue&type=style&index=0&id=537f7a3a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "537f7a3a",
  null
  
)

export default component.exports